import axios from 'axios';
import { trans } from "../i18n/i18n";
import { showToast } from "../_components/toast";
import { Toast } from "../consts/toast";

const tokenMeta = document.querySelector('meta[name="csrf-token"]');
const csrfToken = tokenMeta ? tokenMeta.getAttribute('content') : '';

const axiosInstance = axios.create({
    baseURL: process.env.APP_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'multipart/form-data',
        'X-CSRF-TOKEN': csrfToken,
    },
    timeout: 10000,
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        console.error("Request error occured:", error);

        const skipToast = error?.config?.skipToast ?? false;
        const status = error?.response?.status;
        const message = error?.response?.data?.message ?? error?.config?.toastMsg;

        if (!skipToast) {
            if (status === 419) {
                showToast(trans("The form has expired. Please refresh the page."), Toast.ERROR);
            } else {
                if (message) {
                    showToast(message, Toast.ERROR);
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
